import { Button } from "@/components/ui/button";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Product } from "@/types/Products";
import { Combine, Merge, Split } from "lucide-react";

export default function MergeVariantsDropdown({
    selectedProducts,
    mergeProducts,
    unmergeProducts,
    autoMergeVariants,
}: {
    selectedProducts: Product[];
    mergeProducts: () => void;
    unmergeProducts: () => void;
    autoMergeVariants: () => void;
}) {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="sm">
                    <Combine className="h-4 w-4" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent>
                <DropdownMenuItem
                    disabled={selectedProducts.length <= 1}
                    onClick={mergeProducts}
                >
                    <Merge className="mr-2 h-4 w-4" />
                    Merge selected
                </DropdownMenuItem>
                <DropdownMenuItem
                    disabled={selectedProducts.length === 0}
                    onClick={unmergeProducts}
                >
                    <Split className="mr-2 h-4 w-4" />
                    Unmerge selected
                </DropdownMenuItem>
                <DropdownMenuItem
                    disabled={selectedProducts.length === 0}
                    onClick={autoMergeVariants}
                >
                    <Combine className="mr-2 h-4 w-4" />
                    Auto-merge variants
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
